import { TPropsWithChildren } from '@ftd/types'
import { Table as MantineTable, TableProps as MantineTableProps, TableTrProps } from '@mantine/core'

export const Table: TPropsWithChildren<MantineTableProps> = ({ children, ...props }) => (
  <MantineTable striped highlightOnHover {...props}>
    {children}
  </MantineTable>
)

export const TableHeader: TPropsWithChildren = ({ children }) => <MantineTable.Thead>{children}</MantineTable.Thead>

export const TableBody: TPropsWithChildren = ({ children }) => <MantineTable.Tbody>{children}</MantineTable.Tbody>

interface TableRowProps extends TableTrProps {
  children: React.ReactNode
  ref?: React.RefCallback<HTMLTableRowElement>
  'data-index'?: number
  'data-start'?: number
}

export const TableRow: TPropsWithChildren<TableRowProps> = ({ children, ...props }) => (
  <MantineTable.Tr {...props}>{children}</MantineTable.Tr>
)

interface TableCellProps {
  children: React.ReactNode
  style?: React.CSSProperties
}

export const TableHeaderCell: React.FC<TableCellProps> = ({ children, style }) => (
  <MantineTable.Th style={style}>{children}</MantineTable.Th>
)

export const TableCell: React.FC<TableCellProps> = ({ children, style }) => (
  <MantineTable.Td style={style}>{children}</MantineTable.Td>
)
